import { render, staticRenderFns } from "./memberRankList.vue?vue&type=template&id=89d37da4&"
import script from "./memberRankList.vue?vue&type=script&lang=js&"
export * from "./memberRankList.vue?vue&type=script&lang=js&"
import style0 from "./memberRankList.vue?vue&type=style&index=0&id=89d37da4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports